<template>
    <p>THIS IS THE HOME PAGE</p>
</template>

<style scoped>
    p {
        background-color: yellow;
        color: black;
        text-align: center;
    }
</style>